import { render } from "./HistoryRecipeListPage.vue?vue&type=template&id=aa5a404a&scoped=true&ts=true"
import script from "./HistoryRecipeListPage.vue?vue&type=script&lang=ts"
export * from "./HistoryRecipeListPage.vue?vue&type=script&lang=ts"

import "./HistoryRecipeListPage.vue?vue&type=style&index=0&id=aa5a404a&scoped=true&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa5a404a"]])

export default __exports__